import { render, staticRenderFns } from "./FinancesInvoiceDetails.vue?vue&type=template&id=7f87f985&scoped=true&"
import script from "./FinancesInvoiceDetails.vue?vue&type=script&lang=js&"
export * from "./FinancesInvoiceDetails.vue?vue&type=script&lang=js&"
import style0 from "./FinancesInvoiceDetails.vue?vue&type=style&index=0&id=7f87f985&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f87f985",
  null
  
)

export default component.exports